import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const links = [
  { label: "About", href: "/about" },
  { label: "What We Do", href: "#services" },
  { label: "Our Process", href: "#process" },
  { label: "Our Team", href: "#team" },
  { label: "Apply Now", href: "/apply" },
];

function Logo({ light = true, size = 40 }) {
  return (
    <a href="#top" className="flex items-center flex-shrink-0" data-testid="header-nav-logo">
      <img src="/logo-full.png" alt="TrustDesk — Skilled People. Real Progress." style={{ height: size, width: "auto", maxWidth: "100%", objectFit: "contain" }} />
    </a>
  );
}

export { Logo };

export default function Navbar() {
  const { openBooking } = useSite();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="mx-auto max-w-[1240px] px-4 sm:px-6">
        <div
          className="mt-0 rounded-b-[26px] rounded-t-none sm:rounded-full border-[1.5px] border-[rgba(0,207,255,0.55)] bg-[rgba(9,18,36,0.72)] backdrop-blur-xl px-6 sm:px-8 h-[68px] flex items-center justify-between gap-4"
          style={{ boxShadow: "0 0 28px rgba(0,191,255,0.28), 0 12px 40px rgba(0,0,0,0.45), inset 0 0 18px rgba(0,191,255,0.06)" }}
          data-testid="navbar-pill"
        >
          <Logo />
          <nav className="hidden lg:flex items-center gap-6">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="text-[14px] font-semibold text-white/90 hover:text-cyan-300 transition-colors duration-200 whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3">
            <a href="/admin" className="btn btn-sm btn-outline-light" data-testid="header-nav-login">Team Login</a>
            <button
              className="btn btn-sm btn-primary"
              onClick={() => openBooking(null, "booking")}
              data-testid="header-nav-book-call"
            >
              Book a Free Consultation <ArrowRight size={16} strokeWidth={2.5} />
            </button>
          </div>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Menu"
            data-testid="header-mobile-menu-button"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
          </button>
        </div>
      </div>
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden overflow-hidden"
          >
            <div className="mx-auto max-w-[1240px] px-4 sm:px-6">
              <div className="rounded-b-[26px] border-x-[1.5px] border-b-[1.5px] border-[rgba(0,207,255,0.4)] bg-[rgba(9,18,36,0.88)] backdrop-blur-xl px-6 py-5 flex flex-col gap-3">
                {links.map((l) => (
                  <a key={l.href} href={l.href} onClick={() => setMenuOpen(false)} className="text-white font-semibold py-1">{l.label}</a>
                ))}
                <a href="/admin" className="btn btn-sm btn-outline-light w-fit">Team Login</a>
                <button className="btn btn-sm btn-primary w-fit" onClick={() => { setMenuOpen(false); openBooking(null, "booking"); }}>
                  Book a Free Consultation <ArrowRight size={16} />
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
